import { cn } from '@/lib/utils';

export type HeadingVariantsType = 'h3' | 'h4' | 'h5';
export type TextVariantsType =
    | 'pbold'
    | 'pmedium'
    | 'p'
    | 'psmallbold'
    | 'psmallmedium'
    | 'psmall'
    | 'ctabold'
    | 'cta';

export interface TextProps {
    /**
     * DOM node to be used as the container for the text
     * @default `p`
     */
    renderAs?: TextVariantsType | HeadingVariantsType;
    /**
     * Class names to be added to the text
     */
    className?: string | undefined;
    /**
     * Any compatible React Node
     */
    children: React.ReactNode;
}

/**
 * Generic text component
 * @param TextProps
 */
export const Text = ({ children, renderAs, className }: TextProps) => {
    const baseClass = 'text-greyDark';

    let node;

    switch (renderAs) {
        case 'h3':
            node = (
                <h3
                    className={`sm:text-h3_desktop text-h3_mobile font-heading ${cn(
                        baseClass,
                        className
                    )}`}
                >
                    {children}
                </h3>
            );
            break;
        case 'h4':
            node = (
                <h3
                    className={`sm:text-h4_desktop text-h4_mobile font-heading ${cn(
                        baseClass,
                        className
                    )}`}
                >
                    {children}
                </h3>
            );
            break;
        case 'h5':
            node = (
                <h2
                    className={`sm:text-h5_desktop text-h5_mobile font-heading ${cn(
                        baseClass,
                        className
                    )}`}
                >
                    {children}
                </h2>
            );
            break;
        case 'pbold':
            node = (
                <p
                    className={`sm:text-pbold_desktop text-pbold_mobile font-primary ${cn(
                        baseClass,
                        className
                    )}`}
                >
                    {children}
                </p>
            );
            break;
        case 'pmedium':
            node = (
                <p
                    className={`sm:text-pmedium_desktop text-pmedium_mobile font-primary ${cn(
                        baseClass,
                        className
                    )}`}
                >
                    {children}
                </p>
            );
            break;
        case 'p':
            node = (
                <p
                    className={`sm:text-p_desktop text-p_mobile font-primary ${cn(
                        baseClass,
                        className
                    )}`}
                >
                    {children}
                </p>
            );
            break;
        case 'psmallbold':
            node = (
                <p
                    className={`sm:text-psmallbold_desktop text-psmallbold_mobile font-primary ${cn(
                        baseClass,
                        className
                    )}`}
                >
                    {children}
                </p>
            );
            break;
        case 'psmallmedium':
            node = (
                <p
                    className={`sm:text-psmallmedium_desktop text-psmallmedium_mobile font-primary ${cn(
                        baseClass,
                        className
                    )}`}
                >
                    {children}
                </p>
            );
            break;
        case 'psmall':
            node = (
                <p
                    className={`sm:text-psmall_desktop text-psmall_mobile font-primary ${cn(
                        baseClass,
                        className
                    )}`}
                >
                    {children}
                </p>
            );
            break;
        case 'ctabold':
            node = (
                <p
                    className={`sm:text-ctabold_desktop text-ctabold_mobile font-primary ${cn(
                        baseClass,
                        className
                    )}`}
                >
                    {children}
                </p>
            );
            break;
        case 'cta':
            node = (
                <p
                    className={`sm:text-cta_desktop text-cta_mobile font-primary ${cn(
                        baseClass,
                        className
                    )}`}
                >
                    {children}
                </p>
            );
            break;
        default:
            node = (
                <p
                    className={`sm:text-p_desktop text-p_mobile font-primary ${cn(
                        baseClass,
                        className
                    )}`}
                >
                    {children}
                </p>
            );
    }

    return node;
};
